import React from 'react';
import { I18n } from '@kineticdata/react';
import { InfoMessage } from '@kineticdata/bundle-common';
import { CONTENT_MANAGER_MODE } from '../helpers';
import { getValidContentRenderers } from './';

const NewRenderer = ({ mode, content, activeItem, type, ...props }) => {
  const isViewMode = mode !== CONTENT_MANAGER_MODE.EDIT;
  const id = activeItem && activeItem.id;
  const validRenderers = getValidContentRenderers(type);

  return !!activeItem ? (
    <>
      <h2>
        <I18n>{activeItem.title}</I18n>
      </h2>

      {!isViewMode && (
        <div className="form mb-3">
          <div className="form-group">
            <label htmlFor="title">
              <I18n>Section Title</I18n>
            </label>
            <input
              type="text"
              id="title"
              value={activeItem.title}
              onChange={props.handleContentChange(id, 'title')}
            />
          </div>
        </div>
      )}

      {!isViewMode ? (
        <div className="form mb-3">
          <div className="form-group">
            <label htmlFor="title">
              <I18n>Section Type</I18n>
            </label>
            <div className="mb-3">
              Please select the type of section you would like to add. Disabled
              buttons represent section types that already exist. There may only
              be one instance of each non-standard section type.
            </div>
            <div className="d-flex flex-wrap" style={{ gap: '1.5rem' }}>
              <button
                className="btn btn-primary"
                onClick={() =>
                  props.handleContentChangeDirect(id, 'rendererId')(null)
                }
              >
                Standard
              </button>
              {validRenderers.map(r => (
                <button
                  key={r.ID}
                  className="btn btn-secondary"
                  onClick={() =>
                    props.handleContentChangeDirect(id, 'rendererId')(r.ID)
                  }
                  disabled={content.find(s => s.rendererId === r.ID)}
                >
                  {r.NAME || r.ID}
                </button>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <InfoMessage message="This section is not yet completely configured." />
      )}
    </>
  ) : null;
};

// ID of secton using this renderer
NewRenderer.ID = 'NEW';

export default NewRenderer;
